import { MatDialogRef } from '@angular/material/dialog';
import { AllocationViewProfile } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class AllocationViewProfileItemLoad {
  public static readonly type = '[AllocationViewProfileItem] Load';
  constructor(public id: number) {}
}

export class AllocationViewProfileItemLoadDefault {
  public static readonly type = '[AllocationViewProfileItem] Load Default';
}

export class AllocationViewProfileItemSave {
  public static readonly type = '[AllocationViewProfileItem] Save';

  constructor(public profile: AllocationViewProfile) {}
}

export class AllocationViewProfileItemDelete {
  public static readonly type = '[AllocationViewProfileItem] Delete';

  constructor(public id: number, public dialogRef: MatDialogRef<ConfirmationDialogAfterClosedModel>) {}
}

export class AllocationViewProfileItemInitialState {
  public static readonly type = '[AllocationViewProfileItem] Set Initial State';
}

export class AllocationViewProfileItemDriverViewLoad {
  public static readonly type = '[AllocationViewProfileItem] Driver View Load';
  constructor(public id: number) {}
}
